"use client";

import Link from "next/link";
import { OAuthButtons } from "@/components/auth/oauth-buttons";
import { SignupForm } from "@/components/auth/signup-form";
import { FieldSeparator } from "@/components/ui/field";

export default function SignupPage() {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="space-y-2 text-center">
        <h1 className="text-3xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">
          Create an account
        </h1>
        <p className="text-sm text-zinc-500 dark:text-zinc-400">
          Get started with your Nexus workspace today
        </p>
      </div>

      {/* Form content */}
      <div className="space-y-6">
        {/* OAuth buttons first */}
        <OAuthButtons redirectUrl={null} />

        <FieldSeparator>Or</FieldSeparator>

        {/* Email signup form */}
        <SignupForm />

        {/* Sign in link */}
        <p className="text-center text-sm text-zinc-500 dark:text-zinc-400">
          Already have an account?{" "}
          <Link
            href="/login"
            className="font-medium text-primary transition-colors hover:text-primary/80"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
